import React, {useEffect, useState} from 'react'
import Spacer from '../Spacer/Spacer.jsx'
import styles from './ImageLong.module.scss'
import {getBaseImagePath} from "../../../../ui/catalog/Utils";


const loadImage = (setImageDimensions, bannerImg) => {
	const img = new Image()
	img.src = bannerImg

	img.onload = () => {
		setImageDimensions({
			height: 1920 / 3,
			width: 1920,
		})
	}
	img.onerror = err => {
		console.error(err)
	}
}


const ImageLong = props => {
	const [imageDimensions, setImageDimensions] = useState({})

	const bannerImg = props.params.img

	useEffect(() => {
		loadImage(setImageDimensions, bannerImg)
	}, [])

	return (
		<>
			{Object.keys(imageDimensions).length === 0 ? (
				<></>
			) : (
				<>
					<div className='mblock '>
						<div className={'banner-on-main ' + styles.imageLong}>
							{props.params.url && props.params.url !== '' ? (
								<a href={props.params.url} >
									<picture>
										<source media="(max-width: 768px)" srcSet={getBaseImagePath() + props.params.imgmob} />
										<img src={getBaseImagePath() + bannerImg}
											alt={bannerImg}
											fullpage-banner-size=''
											width={imageDimensions.width}
											height={imageDimensions.height} />
									</picture>
									<img

									/>
								</a>
							) : (
								<picture>
									<source media="(max-width: 768px)" srcSet={getBaseImagePath() + props.params.imgmob} />
									<img src={getBaseImagePath() + bannerImg}
										alt={bannerImg}
										fullpage-banner-size=''
										width={imageDimensions.width}
										height={imageDimensions.height} />
								</picture>
							)}

						</div>
						<div className={styles.imageHeight} style={{height: imageDimensions.height + 'px'}}>
							&nbsp;
						</div>
					</div>
				</>
			)}
			<Spacer />
		</>
	)

}

export default ImageLong
